import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
// Actions
import {
  fetchNutritionValuesByProduct,
  fetchNutritionValuesByProductRequest,
} from '../actions';

import type { Reducer } from 'redux';
import type { Action } from '../../types';
import type { State } from '../types';

const nutritionalValues: Reducer<{ [string]: any }, Action> = handleActions(
  {
    [combineActions(fetchNutritionValuesByProduct)]: {
      next: (state, action) => action.payload,
      throw: (state, action) => state,
    },
  },
  {}
);

//Loading
const initialLoadingState = {
  nutritionalValues: false,
};  

const loading: Reducer<string, Action> = handleActions(
  {
    [fetchNutritionValuesByProduct]: (state, action) => ({ ...state, nutritionalValues: false }),
    [fetchNutritionValuesByProductRequest]: (state, action) => ({
      ...state,
      nutritionalValues: true,
    }),
  },
  initialLoadingState,
);

const reducer: Reducer<State, Action> = combineReducers({
  nutritionalValues,
  loading,
});

export default reducer;
